import React from 'react'

export const Spacer = () => (
    <div>
        <style jsx>{`
            div {
                width: 24px;
            }
        `}</style>
    </div>
)
